import {
    AboutYouBox,
    AccountCircleFilledIcon,
    EditFilledIcon, ExperienceBox,
    HeaderDescription,
    InputBlock, LayersFilledIcon, QualificationBox,
    SectionTitle, WorkFilledIcon, PhotoBox,
    JobSeekingStatusContainer,
    JobSeekingStatusTitle,
    JobSeekingStatusDescription,
    RadioGroupContainer,
    RadioOption,
    RadioDescription
} from "../ProfilePage.styles";
import MaterialInput from "../../../../components/Inputs/MaterialInput/MaterialInput";
import {FormMaterialInput} from "../../../../components/Inputs/MaterialInput/FormMaterialInput";
import MaskedInput from "react-input-mask";
import React, {FC, useEffect, useRef, useState} from "react";
import {useForm, useWatch} from "react-hook-form";
import {joiResolver} from "@hookform/resolvers/joi";
import {AutocompleteProps, HygienistProps, PositionProps, SkillsProps, HYGIENIST_TYPES, JOB_SEEKING_STATUS} from "../../../../utils/types";
import {exitReact, getTypeByRoleNumber, mimeTypeToExtension} from "utils";
import {useHistory, useLocation} from "react-router";
import joi from "joi";
import {Autocomplete} from "../../../../utils/autocomplete";
import styles from "../../../dentist/PostJobPage/PostJob.module.scss";
import {Switch} from "@mui/material";
import dayjs from "dayjs";
import FullscreenModal from "../../../../components/FullscreenModal";
import _ from "lodash";

import Api from "../../../../api";
import {CrossButtonBlack} from "../../../../components/Buttons/CrossButton";
import clsx from "clsx";
import {SimpleModal} from "../../../../components/Modal";
import {StyledButton} from "../../../../components/Buttons/DefaultButton/DefaultButton.styles";
import * as ls from "utils/localStorage";
import FixedLoader from "components/FixedLoader";
import { isWritingAssistV2Enabled } from "utils/writingAssistV2";
import ProfilePhotoActions from "./ProfilePhotoActions";
import ReferralCodeCard from "components/ReferralCodeCard/ReferralCodeCard";
import TalentAddressUnitInput from "components/TalentAddressUnitInput";
import { composeTalentAddress, splitTalentAddress, paymentEmailLabel } from "utils/talentAddress";

// @ts-ignore
const TempStars = window.TempStars;

const schema = joi
    .object({
        firstName: joi.string().label('Legal first name').required(),
        lastName: joi.string().label('Legal last name').required(),
        preferredName: joi.string().label('Preferred name').allow(null, '').max(50),
        address: joi.string().label('Address').required(),
        addressUnit: joi.string().allow('').max(100),
        city: joi.string().label('City').required(),
        province: joi.string().label('Province').required(),
        postalCode: joi.string().label('Postal Code').required(),
        phone: joi.string().label('Phone').required(),
        photoUrl: joi.string().label('Photo Url').allow(null),
        eTransferEmail: joi.string().email({ tlds: { allow: false } }).label('Payment email').allow(null, '').max(100),
        weeklyNewsletter: joi.boolean().label('Weekly Newsletter').required(),
        receivePostedShifts: joi.boolean().label('Receive Posted Shifts').required(),
        showForHire: joi.number().valid(0, 1, 2, null).label('Job-Seeking Status').allow(null),
    })
    .required()


const filterPhoneNumberToFormat = (phoneNumber: string | undefined): number => {
    const arr = phoneNumber?.match(/\d+/g)
    return Number(arr?.slice(1).join(''))
}

const normalizePhoneDigits = (phone: string | number | undefined | null): string => {
    const digits = String(phone ?? '').replace(/\D/g, '')
    if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1)
    return digits
}

const dataURItoBlob = (dataURI: string): Blob => {
	const [meta, base64] = dataURI.split(',');
	const mime = meta.split(':')[1].split(';')[0];
	const binary = atob(base64);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return new Blob([bytes], { type: mime });
};

const uploadPhoto = async (imageSrc: string, userId: number, imageType: string): Promise<string | null> => {
	const ext = mimeTypeToExtension(imageType);
	if (!ext.length) {
		console.error('uploadPhoto: unsupported image type', imageType);
		return null;
	}

	try {
		const blob = dataURItoBlob(imageSrc);
		const fileName = userId + '_' + dayjs().unix() + '.' + ext;
		const result = await TempStars.Api.getAwsUploadCredentials(imageType, fileName);
		await fetch(result.signedRequest, {
			method: 'PUT',
			headers: { 'Content-Type': imageType },
			body: blob,
		});
		return result.url;
	} catch (e: any) {
		console.error('uploadPhoto: upload failed', e);
		return null;
	}
}

const viewStripeAcc = async () => {
    try {
        const app = (window as any).app;
        app?.showPreloader?.('Redirecting. Please wait...');
        const link = await Api.getStripeAccountLoginLink();
        app?.hidePreloader?.();
        if (link?.url) {
            // @ts-ignore - cordova InAppBrowser
            if ((window as any).cordova?.InAppBrowser) {
                // @ts-ignore
                cordova.InAppBrowser.open(link.url, '_system', 'location=yes');
            } else {
                window.open(link.url, '_blank');
            }
        }
    } catch (e: any) {
        const app = (window as any).app;
        app?.hidePreloader?.();
        app?.alert?.(e?.message || 'Failed to open Stripe Express. Please try again.');
        console.error('Failed to get Stripe link:', e);
    }
}

const JOB_SEEKING_OPTIONS = [
    {
        id: 'temping-only-profile',
        value: JOB_SEEKING_STATUS.TEMPING_ONLY,
        title: 'Temping only',
        desc: 'Your job search status is private. You can choose Job Board alerts separately.',
    },
    {
        id: 'open-to-opportunities-profile',
        value: JOB_SEEKING_STATUS.OPEN_TO_OPPORTUNITIES,
        title: 'Open to great opportunities',
        desc: 'Let offices know you are open to a great opportunity.',
    },
    {
        id: 'actively-looking-profile',
        value: JOB_SEEKING_STATUS.ACTIVELY_LOOKING,
        title: 'Actively looking for a position',
        desc: 'Let offices know you are actively looking for a position.',
    },
] as const;

export const Profile: FC<{
    hygienist: {
        skills: SkillsProps[],
    } & HygienistProps,
    setOpenAboutModal: () => void,
    setOpenCoverLetterModal: () => void,
    setOpenPositionModal: () => void,
    setOpenQualificationModal: () => void,
    setOpenSuccessModal: () => void,
    workExperience: PositionProps[],
    isAboutChanged: boolean,
    isCoverLetterChanged: boolean,
    onSubmit: (e: any) => void
}> = (
    {
        hygienist,
        workExperience,
        setOpenAboutModal,
        setOpenCoverLetterModal,
        setOpenPositionModal,
        setOpenQualificationModal,
        isAboutChanged,
        isCoverLetterChanged,
        onSubmit,
    }) => {
    const history = useHistory();
    const location = useLocation<{ focusExpressPayouts?: boolean }>();

    const userAccount: {
        email: string;
        dentistId?: number,
        hygienistId?: number,
        dentist?: any,
        hygienist?: any
        id: number
    } = ls.get('userAccount') || {}

    const inputPhotoRef = useRef<HTMLInputElement>(null)
    const [imageSrc, setImageSrc] = useState<string | null>(hygienist?.photoUrl);
    const [imageType, setImageType] = useState<string>('');
    const [shortAddress, setAddress] = useState<string | undefined>(splitTalentAddress(hygienist?.address).street);
    const isHygienistOrAssistant = hygienist?.type in [HYGIENIST_TYPES.HYGIENIST, HYGIENIST_TYPES.ASSISTANT];
    const [onExitModal, setOnExitModal] = useState(false)
    const [stripeActiveStatus, setStripeActiveStatus] = useState(false)
    const payoutButtonRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        if (!location.state?.focusExpressPayouts || !hygienist?.id) return;
        payoutButtonRef.current?.scrollIntoView({ block: 'center' });
        payoutButtonRef.current?.focus({ preventScroll: true });
    }, [location.key, location.state?.focusExpressPayouts, hygienist?.id]);
    const [loading, setLoading] = useState(false)
    // T2-5853: confirm-before-remove modal for the profile photo. Previously a
    // tap on the avatar silently cleared the image, which wiped photos by
    // accident. Now a tap replaces the image (file chooser), and the Remove
    // action lives on an explicit "×" overlay with this confirmation.
    const [photoRemoveConfirmOpen, setPhotoRemoveConfirmOpen] = useState(false)
    
    const [visibleAddress, setVisibleAddress] = useState('');
    const addressInputRef = useRef<HTMLInputElement>(null);

    const [prevData, setPrevData] = useState({
        firstName: hygienist?.firstName,
        lastName: hygienist?.lastName,
        preferredName: hygienist?.preferredName || '',
        province: hygienist?.province,
        city: hygienist?.city,
        postalCode: hygienist?.postalCode,
        address: splitTalentAddress(hygienist?.address).street + ', ' + hygienist?.city + ' ' + hygienist?.province,
        addressUnit: splitTalentAddress(hygienist?.address).unit,
        phone: '+1' + hygienist?.phone,
        photoUrl: hygienist?.photoUrl || null,
        eTransferEmail: hygienist?.etransferEmail,
        weeklyNewsletter: !!hygienist?.WeeklyNewsletter,
        receivePostedShifts: !!hygienist?.receivePostedShifts,
        showForHire: hygienist?.showForHire !== undefined && hygienist?.showForHire !== null ? 
                    Number(hygienist.showForHire) : null,
    })

    const {
        control,
        handleSubmit,
        setValue,
        formState: {errors},
        setError,
        getValues,
        register,
        reset,
    } = useForm({
        defaultValues: prevData as any,
        resolver: joiResolver(schema) as any,
    });

    const addressUnit = useWatch({control, name: "addressUnit"}) || "";
    const receivePostedShifts = useWatch({control, name: "receivePostedShifts"})
    const weeklyNewsletter = useWatch({control, name: "weeklyNewsletter"})
    const showForHire = useWatch({control, name: "showForHire"})

    useEffect(() => {
        if (hygienist?.address && hygienist?.city && hygienist?.province) {
            const parsed = splitTalentAddress(hygienist.address);
            setVisibleAddress(`${parsed.street}, ${hygienist.city} ${hygienist.province}`);
            setAddress(parsed.street);
            setValue("addressUnit", parsed.unit);
        }
    }, [hygienist?.address, hygienist?.city, hygienist?.province]);

    useEffect(() => {
        interface EffectiveAutocompleteData {
            state: string;
            city?: string;
            postalCode?: string;
            address?: string;
            buildingNumber?: string;
            street?: string;
            subpremise?: string;
            valueEqual?: boolean;
        }

        const timerId = setTimeout(() => {
            if (!addressInputRef.current) {
                return
            }
            Autocomplete.init(
                { country: hygienist?.country },
                (data: EffectiveAutocompleteData) => {
                    const {
                        state: province,
                        city,
                        postalCode,
                        address: streetAddress,
                        valueEqual
                    } = data;

                    if (valueEqual && streetAddress && city && province) {
                        const parsed = splitTalentAddress(streetAddress);
                        const fullAddressString = `${parsed.street}, ${city} ${province}`;
                        if (!getValues("addressUnit") && parsed.unit) setValue("addressUnit", parsed.unit);

                        setVisibleAddress(fullAddressString);
                        setValue('address', fullAddressString, { shouldValidate: true, shouldDirty: true });
                        setValue('city', city, { shouldValidate: true, shouldDirty: true });
                        setValue('province', province, { shouldValidate: true, shouldDirty: true });
                        setValue('postalCode', postalCode || '', { shouldValidate: true, shouldDirty: true });
                        setAddress(parsed.street);
                    }
                }
            );
        }, 0);

        TempStars.Api.checkCreationStatus(hygienist.id, true).then((status: boolean) => setStripeActiveStatus(status));

        return () => {
            clearTimeout(timerId);
            Autocomplete.removeListener();
        };
    }, [hygienist?.country, hygienist?.id, setValue, setAddress, setVisibleAddress]);

    useEffect(() => {
        // Explicitly set showForHire value when component mounts or hygienist data changes
        if (hygienist?.showForHire !== undefined && hygienist?.showForHire !== null) {
            const showForHireValue = Number(hygienist.showForHire);
            if ([0, 1, 2].includes(showForHireValue)) {
                setValue('showForHire', showForHireValue, { shouldValidate: true });
            }
        }
    }, [hygienist?.showForHire, setValue]);

    const webPhotoHandler = (photoUrl: any) => {
        const file = photoUrl.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            if(event) {
                setImageSrc(event?.target?.result as string)
                setImageType(file.type as string)
                setValue('photoUrl', event?.target?.result as string)
            }
        };
        reader.readAsDataURL(file);
    }

    const lastPosition = workExperience[workExperience.length - 1]
    const qualifications = hygienist?.skills?.filter((skill: SkillsProps) =>
        skill.license === 0 && skill.qualification === 0
    ).map((skill: SkillsProps) => skill.label).join(',\n')

    const phoneHandler = (e: any) => {
        setValue('phone', e.target.value)
    }

    const profileSubmitHandler = async (data: any) => {
        setLoading(true)
        const isEqual = _.isEqual({...data}, {...prevData})

        if (isEqual && !isAboutChanged && !isCoverLetterChanged) {
            setLoading(false)
            return
        }

        let canonicalAddress: string;
        try { canonicalAddress = composeTalentAddress(shortAddress, data.addressUnit); }
        catch (error) {
            setLoading(false);
            setError('address', { type: 'manual', message: (error as Error).message });
            return false;
        }
        const filteredPhone = filterPhoneNumberToFormat(data.phone)
        const formPhoneDigits = filteredPhone ? String(filteredPhone) : ''
        const existingPhoneDigits = normalizePhoneDigits(hygienist?.phone)
        const phoneUnchanged = formPhoneDigits.length >= 10 && formPhoneDigits === existingPhoneDigits

        if (formPhoneDigits) {
            if (formPhoneDigits.length < 10) {
                setLoading(false)
                return setError('phone', {type: "manual", message: "Phone number is too short."});
            } else if (!phoneUnchanged) {
                try {
                    const type = getTypeByRoleNumber(Number(hygienist.type));
                    await Api.checkUniqueHygienistPhoneNumber({phone: filteredPhone, type})
                } catch (e: any) {
                    setLoading(false)
                    return setError('phone', {type: "manual", message: "Oops! This phone number seems to already be in use."});
                }
            }
        }

        setPrevData({...data})

        const {addressUnit: _addressUnit, ...profileData} = data;
        profileData.address = canonicalAddress;

        let photoFileName = data.photoUrl

        if (imageSrc && imageType) {
            const uploaded = await uploadPhoto(data.photoUrl, userAccount.id, imageType as string);
            if (!uploaded) {
                setLoading(false);
                setError('photoUrl', { type: 'manual', message: 'Photo upload failed. Please try again.' });
                return;
            }
            photoFileName = uploaded;
        }

        setLoading(false)
        const trimmedPreferred = (data.preferredName || '').trim();
        return onSubmit({
            ...profileData,
            preferredName: trimmedPreferred ? trimmedPreferred.slice(0, 50) : null,
            photoUrl: photoFileName,
            photo: imageSrc,
            phone: formPhoneDigits ? Number(formPhoneDigits) : hygienist?.phone,
        })
    }

    function goToDeleteAccount(){
        const firstName = hygienist?.firstName
        history.push('hygienistDeleteAccount', {firstName: firstName})
    }

    const onExit = () => {
        history.push('loading')
        if(isHygienistOrAssistant) {
            ;(window as any).TempStars?.App?.goReact('hygienistHome')
        } else {
            history.push('jobPostsList')
        }
    }

    const exitWithSaving = async (data: any) => {
        setOnExitModal(false);
        if (await profileSubmitHandler(data) === false) return;
        onExit();
    }

    const onCloseHandler = (data: any) => {
        const isEqual = _.isEqual({...data}, {...prevData})

        if (isEqual && !isAboutChanged && !isCoverLetterChanged) {
            return onExit()
        } else {
            setOnExitModal(true)
        }
    }

    const handleJobSeekingStatusChange = (value: JOB_SEEKING_STATUS) => {
        setValue("showForHire", value, { shouldValidate: true, shouldDirty: true });
    }

    return (
        <>
            <SimpleModal isOpen={onExitModal}>
                <>
                    <div className={styles.titleContainer}>
                        <div className={styles.popupTitle}>Profile</div>
                        <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                          onClick={() => setOnExitModal(false)}/>
                    </div>
                    <div className={styles.description}>
                        Please remember to save your changes before exiting.
                    </div>
                    <StyledButton
                        variant="outlined"
                        size="large"
                        onClick={handleSubmit(exitWithSaving)}
                    >
                        Save and Exit
                    </StyledButton>
                    <StyledButton
                        variant="outlined"
                        size="large"
                        onClick={() => {
                            setOnExitModal(false);
                            onExit();
                        }}
                    >
                        Exit Without Saving
                    </StyledButton>
                </>
            </SimpleModal>

            <FullscreenModal
                title={'Edit Profile'}
                isOpen={true}
                buttonText={'Update'}
                deleteButtonText="Delete My Account"
                onClose={handleSubmit(onCloseHandler)}
                onSubmit={handleSubmit(profileSubmitHandler)}
                onDelete={goToDeleteAccount}
                stickyBottom={false}
                hideNotificationBell={true}
                useStandardBack={true}
                coverViewport={true}
                reserveTopNav={true}
                >
                <HeaderDescription>Add/Change your Profile Information here</HeaderDescription>

                <ReferralCodeCard
                    key={`${userAccount.id}:${location.key}`}
                    audience="talent"
                    country={Number(hygienist.country) === 1 ? 1 : 0}
                />

                    <PhotoBox className="list-block inset inputBox">
                        <input
                            style={{display: 'none'}}
                            type='file'
                            name={'photoUrl'}
                            ref={inputPhotoRef}
                            onChange={(e: any) => webPhotoHandler(e.target)}
                            accept="image/gif,image/jpeg,image/png,image/jpg,image/*"
                        />

                        <ProfilePhotoActions
                            imageSrc={imageSrc}
                            onUpload={() => inputPhotoRef.current?.click()}
                            onRequestRemove={() => setPhotoRemoveConfirmOpen(true)}
                        />
                        <SimpleModal
                            isOpen={photoRemoveConfirmOpen}
                            onClose={() => setPhotoRemoveConfirmOpen(false)}
                        >
                            <div style={{ padding: '1rem' }}>
                                <div className={styles.popupTitle} style={{ marginBottom: '0.5rem' }}>
                                    Remove Profile Photo?
                                </div>
                                <div className={styles.description} style={{ marginBottom: '1rem' }}>
                                    This will delete your current profile photo. You can upload a new one any time.
                                </div>
                                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                    <StyledButton
                                        variant="outlined"
                                        size="large"
                                        onClick={() => setPhotoRemoveConfirmOpen(false)}
                                    >
                                        Cancel
                                    </StyledButton>
                                    <StyledButton
                                        variant="contained"
                                        size="large"
                                        onClick={() => {
                                            setImageSrc(null);
                                            setImageType('');
                                            setValue('photoUrl', null);
                                            setPhotoRemoveConfirmOpen(false);
                                        }}
                                    >
                                        Remove
                                    </StyledButton>
                                </div>
                            </div>
                        </SimpleModal>
                    </PhotoBox>

                    <InputBlock className="list-block inset">
                        <MaterialInput
                            label="Legal first name"
                            type={"text"}
                            id={'fName'}
                            name={"firstName"}
                            disabled={true}
                            defaultValue={hygienist?.firstName}
                        />
                        <MaterialInput
                            label="Legal last name"
                            id={'lName'}
                            name={"lastName"}
                            type={"text"}
                            disabled={true}
                            defaultValue={hygienist?.lastName}
                        />
                        <FormMaterialInput
                            control={control}
                            label="Preferred name"
                            id={'preferredName'}
                            name={"preferredName"}
                            type={"text"}
                            helperText={"What you go by day-to-day (optional)."}
                        />
                    </InputBlock>
                    <SectionTitle><div>Payment Info</div></SectionTitle>
                    <p>Your payment info is only shared with an office when you explicitly tap Send for that office.</p>
                    <InputBlock className="list-block inset">
                        <MaterialInput
                            className={'no-fastclick'}
                            label="Mailing Address"
                            id={'autocomplete'}
                            name={"address"}
                            type={"text"}
                            value={visibleAddress}
                            inputRef={addressInputRef}
                            onChange={(e) => {
                                setVisibleAddress(e.target.value);
                            }}
                            error={!!errors?.address}
                            helperText={errors?.address?.message as string}
                            shrink={true}
                        />

                        <TalentAddressUnitInput scope="talent-profile" value={addressUnit}
                            onChange={value => setValue('addressUnit', value, { shouldDirty: true })} />
                    </InputBlock>
                    <InputBlock className="list-block inset">
                        <FormMaterialInput control={control} label={paymentEmailLabel(hygienist?.country)}
                            type="email" id="eTransferEmail" name="eTransferEmail" />
                        <div />
                    </InputBlock>
                    <InputBlock className="list-block inset">
                        {/* @ts-ignore */}
                        <MaskedInput
                            mask="+1(999) 999-9999"
                            defaultValue={getValues('phone')}
                            onChange={phoneHandler}
                        >
                            {/* @ts-ignore */}
                            {(inputProps: any) => (<MaterialInput
                                {...inputProps}
                                id={'phone'}
                                name={"phone"}
                                type={'text'}
                                label={'Cell Phone'}
                                error={!!errors?.phone}
                                helperText={errors?.phone?.message}
                            />)}
                        </MaskedInput>
                    </InputBlock>

                {isHygienistOrAssistant && <InputBlock className="list-block inset">
                    <StyledButton
                        variant="contained"
                        size="large"
                        className="no-fastclick"
                        onClick={() => viewStripeAcc()}
                        ref={payoutButtonRef}
                        data-testid="talent-profile-express-payouts"
                    >
                        {stripeActiveStatus ? 'View Express Payouts' : 'Set Up Express Payouts'}
                    </StyledButton>
                    <div></div>
                </InputBlock>}

                {isHygienistOrAssistant && (
                    <JobSeekingStatusContainer>
                        <JobSeekingStatusTitle>Job-Seeking Status</JobSeekingStatusTitle>
                        <JobSeekingStatusDescription>
                            Let dental offices know if you're actively looking for a permanent position when you send temp offers.
                            This status will be visible to offices when you choose to share it.
                        </JobSeekingStatusDescription>
                        
                        <RadioGroupContainer role="radiogroup">
                            {JOB_SEEKING_OPTIONS.map(({ id, value, title, desc }) => (
                                <RadioOption
                                    key={value}
                                    className={showForHire === value ? "selected" : ""}
                                    onClick={() => handleJobSeekingStatusChange(value)}
                                >
                                    <input
                                        type="radio"
                                        id={id}
                                        name="showForHire"
                                        value={value}
                                        checked={showForHire === value}
                                    />
                                    <label htmlFor={id}>
                                        {title}
                                        <RadioDescription>{desc}</RadioDescription>
                                    </label>
                                </RadioOption>
                            ))}
                        </RadioGroupContainer>
                        
                    </JobSeekingStatusContainer>
                )}

                    <AboutYouBox className="list-block inset" onClick={setOpenAboutModal}>
                        <SectionTitle>
                            <div>
                                <AccountCircleFilledIcon/>
                                About Me
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {hygienist?.about || 'Add a catchy bio with our AI.'}
                        </div>
                    </AboutYouBox>

                    {isWritingAssistV2Enabled() ? <AboutYouBox className="list-block inset" onClick={setOpenCoverLetterModal}>
                        <SectionTitle>
                            <div>
                                <AccountCircleFilledIcon/>
                                Cover Letter
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {hygienist?.baseCoverLetter ? 'Edit your cover letter.' : 'Write a cover letter to stand out to employers.'}
                        </div>
                    </AboutYouBox> : null}

                    {isHygienistOrAssistant &&
                    <QualificationBox className="list-block inset" onClick={setOpenQualificationModal}>
                        <SectionTitle>
                            <div>
                                <LayersFilledIcon/>
                                Qualifications & Skills
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {qualifications}
                        </div>
                    </QualificationBox>
                    }

                    <ExperienceBox className="list-block inset" onClick={setOpenPositionModal}>
                        <SectionTitle>
                            <div>
                                <WorkFilledIcon/>
                                Work Experience
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {lastPosition ? `${lastPosition.jobTitle}, ${lastPosition.companyName}\n${dayjs(lastPosition.fromDate).format('MMM YYYY')} - ${dayjs(lastPosition.toDate).format('MMM YYYY')}`
                                : 'Where have you worked before?'}
                        </div>
                    </ExperienceBox>
                    {isHygienistOrAssistant &&
                    <div className={styles.leftContainer}>
                        <Switch
                            {...register("weeklyNewsletter")}
                            checked={weeklyNewsletter}
                            name="weeklyNewsletter"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                        <div className={styles.instaBook}>Receive Weekly E-mail</div>
                    </div>
                    }

                    {isHygienistOrAssistant && 
                    <div className={styles.leftContainer}>
                        <Switch
                            {...register("receivePostedShifts")}
                            checked={receivePostedShifts}
                            name="receivePostedShifts"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                        <div className={styles.instaBook}>Receive Temping Shift Notification E-mails</div>
                    </div>
                    }
            </FullscreenModal>

            <FixedLoader
                loading={loading}
            />
        </>
    )
}
